import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { EntityReviewService } from '@/domain/shared/services/EntityReviewService';
import { toast } from '@/components/ui/use-toast';
import * as Sentry from "@sentry/react";
import { ComplianceToggle } from '@/components/compliance/ComplianceToggle';
import { ErrorFallback } from '@/components/error-boundary/ErrorFallback';

export function ComplianceSettings() {
  const entityReviewService = EntityReviewService.getInstance();

  useEffect(() => {
    // Always set to opensanctions
    entityReviewService.setDefaultMechanism('opensanctions');
  }, []);

  const handleSave = () => {
    entityReviewService.setDefaultMechanism('opensanctions');
    toast({
      title: "Settings saved",
      description: `Compliance settings saved`,
    });
  };

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Compliance Settings</CardTitle>
        <CardDescription>
          Configure compliance check settings
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          <div>
            <h3 className="text-lg font-medium">Review Mechanism</h3>
            <p className="text-sm text-muted-foreground mt-1">
              The system performs automated compliance checks
            </p>
            <div className="mt-3 p-3 bg-muted rounded-md">
              <p className="font-medium">Sanctions Screening</p>
              <p className="text-sm mt-1">
                Real-time compliance checks against global sanctions lists and PEPs databases.
              </p>
            </div>
          </div>
          
          <div className="mt-6">
            <Button onClick={handleSave}>
              Save Settings
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default Sentry.withErrorBoundary(ComplianceSettings, {
  fallback: ErrorFallback,
  showDialog: true,
}); 